import React, { Component } from 'react'
import './BookCard.scss'
import { ConfigContext } from 'providers/ConfigContext';
import SolidButton from 'components/content/Button/SolidButton';
import OutlineButton from 'components/content/Button/OutlineButton';
import BookALikeButton from './BookALikeButton/BookALikeButton';
import checkMarkRed from 'images/check-mark-red.svg';

export class BookCard extends Component {
	static contextType = ConfigContext;
	constructor(props) {
		super(props);
		this.generateFacet = this.generateFacet.bind(this);
		this.generateContributorLink = this.generateContributorLink.bind(this);
		this.generateGrade = this.generateGrade.bind(this);
		this.generateDisplayPrice = this.generateDisplayPrice.bind(this);
		this.formatGuidedReadingValue = this.formatGuidedReadingValue.bind(this);
	}
	
	generateFacet(facetType) {
		let facets = this.props.facets
		let facetValue = ''
		if(facets !== ''){
			let facetValues = facets.filter(facet => facet.name === facetType).map(filteredFacet => filteredFacet.values)[0]
			if(facetValues){
				if(facetValues.length === 1){
					facetValue = facetValues[0]
				}
				else if(facetValues.length > 1){
					facetValue = Math.min(...facetValues) + "–" + Math.max(...facetValues)
				}
			}
			if(facetType==="lexileLevel"){
				let lexileCode = facets.filter(facet => facet.name === 'lexileCode').map(filteredFacet => filteredFacet.values)[0]
				if(lexileCode){
					lexileCode = lexileCode[0].substring(0,2)
					facetValue = lexileCode + facetValue + "L"
				}
			}
		}
		return facetValue
	}

	formatGuidedReadingValue(value) {
		const A = 'A'.charCodeAt(0);
		if (value === 27)
			{ return 'Z+'; }
		return String.fromCharCode(A + (value - 1));
	}
	
	generateContributorLink(contributorType) {
		return this.context.tso.origin + '/teachers-ecommerce/teacher/search-results.html?search=1&text=' + this.props[contributorType]
	}

	generateGrade() {
		return this.props.grade.replace(' - ', '–')
	}
	
	generateDisplayPrice() {
		return this.props.displayPrice.toFixed(2)
	}
	
	render() {
		return (
			<div className="bookCard">
				<div className="bookCard--bookDetails">
					<a href={this.props.url} tabIndex="0" className="bookCard--cover-link" target="_blank" rel="noopener noreferrer">
						<img src={this.props.img} className="bookCard--cover" alt={this.props.title + ' Cover'}/>
					</a>
					<div className="bookCard--info">    
						<p className="bookCard--format">{this.props.format}</p>
						<a href={this.props.url} className="bookCard--title" tabIndex="0" target="_blank" rel="noopener noreferrer" >{this.props.title}</a>
						<div className="bookCard--contributors">
							{this.props.author &&
								<p className="bookCard--author">By<a href={this.generateContributorLink("author")} target="_blank" rel="noopener noreferrer" >{this.props.author}</a></p>
							}
							{this.props.illustrator &&
								<p className="bookCard--illustrator">Illustrator<a href={this.generateContributorLink("illustrator")} target="_blank" rel="noopener noreferrer" >{this.props.illustrator}</a></p>
							}
						</div>
						{/* Need a desktop and mobile version due to the way the container is organized */}
						{this.props.handleBookALikeClick && <BookALikeButton handleBookALikeClick={() => this.props.handleBookALikeClick(this.props.isbn)} type="desktop"/>}
					</div>
				</div>
				{this.props.handleBookALikeClick && <BookALikeButton handleBookALikeClick={() => this.props.handleBookALikeClick(this.props.isbn)} type="mobile"/>}
				<div className="bookCard--facets">  
					<ul>
						{this.props.grade &&
							<li>
								<span className="bookCard--facetTitle">Grades</span>
								<span className="bookCard--facetValue">{this.generateGrade()}</span>
							</li>
						}
						{this.generateFacet('guidedReadingLevel') &&
							<li>
								<span className="bookCard--facetTitle">Guided Reading Level</span>
								<span className="bookCard--facetValue">{this.formatGuidedReadingValue(this.generateFacet('guidedReadingLevel'))}</span>
							</li>
						}
						{this.generateFacet('lexileLevel') &&
							<li>
								<span className="bookCard--facetTitle">Lexile<sup>®</sup> Measure</span>
								<span className="bookCard--facetValue">{this.generateFacet('lexileLevel')}</span>
							</li>
						}
						{this.generateFacet('draLevel') &&
							<li>
								<span className="bookCard--facetTitle">DRA Level</span>
								<span className="bookCard--facetValue">{this.generateFacet('draLevel')}</span>
							</li>
						}
						{this.generateFacet('acceleratedReaderLevel') &&
							<li>
								<span className="bookCard--facetTitle">ACR Level</span>
								<span className="bookCard--facetValue">{this.generateFacet('acceleratedReaderLevel')}</span>
							</li>
						}
					</ul>
				</div>
				<div className="bookCard--commerce">
					<div className="bookCard--price">
						{this.props.displayPrice && <p className="bookCard--listPrice">${this.generateDisplayPrice()}</p>}
						{this.props.listPrice > this.props.displayPrice ? <p className="bookCard--salePrice">${this.props.listPrice}</p>:''}
					</div>
					<SolidButton 
						text={this.props.addToCartButtonLabel}
						className="bookCard--addButton"
						disabled={this.props.addToCartButtonLabel === "OUT OF STOCK"}
						handleClick={() => this.props.handleAddToCart(
							{
								isbn: this.props.isbn,
								img: this.props.img,
								title: this.props.title,
								displayPrice: this.props.displayPrice,
								listPrice: this.props.listPrice,
								salePrice: this.props.salePrice,
								author: this.props.author,
								format: this.props.format,
								guidedReadingLevel: this.formatGuidedReadingValue(this.generateFacet('guidedReadingLevel')),
								grades: this.generateGrade()
							}
						)}
					/>
					{this.props.inWishlist ?
						<OutlineButton
							text="VIEW WISHLIST"
							icon={checkMarkRed}
							iconLeft
							className="saveToWishlistButton"
							handleClick={() => window.open(`${this.context.tso.demandware}/Wishlist-Show`)}
						/> :
						<OutlineButton
							text="SAVE TO WISHLIST"
							className="saveToWishlistButton"
							handleClick={() => this.props.handleWishlistClick({
								productId: this.props.productId,
								image: this.props.img,
								title: this.props.title,
								format: this.props.format,
								displayPrice: this.props.displayPrice,
								listPrice: this.props.listPrice,
								author: this.props.author,
								guidedReadingLevel: this.formatGuidedReadingValue(this.generateFacet('guidedReadingLevel')),
								grades: this.generateGrade(),
								isbn: this.props.isbn
							})}
						/>
					}
				</div>
			</div>
		)
	}
}

export default BookCard